import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthWebsiteGuard } from './@Modules/@website/@auth/auth-material/auth-website.guard';
import { LicenseAgreementGuard } from './@Modules/@website/@auth/auth-material/license-agreement.guard';
import { SurveyAttemptByUserComponent } from './@Free-pages/survey-attempt-by-user/survey-attempt-by-user.component';

const routes: Routes = [
  {path:'', redirectTo:'auth', pathMatch:'full'},
  { path: 'auth',loadChildren: () =>import('./@Modules/@website/@auth/auth.module').then((m) => m.AuthModule)},
  {path:'website',loadChildren:()=>import('./@Modules/@website/website-home.module').then(m=>m.WebsiteHomeModule)},
  { path: 'client-admin',canActivate: [AuthWebsiteGuard, LicenseAgreementGuard], loadChildren: () =>import('./@Modules/@client-admin/client-admin-home.module').then((m) => m.ClientAdminHomeModule)},
  { path: 'compare', loadChildren: () => import('./@Modules/@website/compare/compare.module').then(m => m.CompareModule) },
  { path: 'survey-attempt/:id', component:SurveyAttemptByUserComponent,title:'ikoo survey'},
  {path:'**',redirectTo:'auth',pathMatch:'full'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
